/* eslint-disable eslint-comments/no-restricted-disable */
/* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { clientSideOnly } from '@atlassian/jira-common-client-side-only/src/index.tsx';

export const communicationsStatusPagePreviewEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		clientSideOnly(
			import(
				/* webpackChunkName: "async-communications-status-page-preview-entrypoint" */ './src/ui/StatuspagePreviewPage'
			).then((module) => module.StatuspagePreviewPage),
		),
	),
	getPreloadProps: () => {
		return {};
	},
});
